// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reset-password-container {
    width: 35%;
    margin: 10% 30%;
    padding: 0;
    border: 10px solid #00468C;
    border-radius: 8px;
    background-color: #f9f9f9;
  }
  
  .reset-header {
    width: 100%;
    background-color: #00468C;
    text-align: center;
    margin: 0%;
    padding: 4% 0;
  }

  .reset-header h2 {
    color: #fff;
    margin: 0%;
  }
  
  .reset-form {
    margin: 5%;
    align-items: center;
  }

  .reset-group {
    align-items: center;
    padding: 5%;
  }

  .reset-group input {
    width: 92%;
    padding: 4%;
    font-size: large;
  }
  
  .reset-group label {
    display: block;
    font-weight: bold;
  }

  .reset-button {
    align-items: center;
    padding: 5%;
  }
  
  .submit-reset {
    width: 100%;
    padding: 4%;
    background-color: #4CAF50;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .submit-reset:hover {
    background-color: #45a049;
  }
  
  .error-message {
    color: red;
    text-align: center;
  }
  
  .success-message {
    color: green;
    text-align: center;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/ResetPassword/ResetPassword.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,eAAe;IACf,UAAU;IACV,0BAA0B;IAC1B,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,aAAa;EACf;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,UAAU;IACV,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB","sourcesContent":[".reset-password-container {\n    width: 35%;\n    margin: 10% 30%;\n    padding: 0;\n    border: 10px solid #00468C;\n    border-radius: 8px;\n    background-color: #f9f9f9;\n  }\n  \n  .reset-header {\n    width: 100%;\n    background-color: #00468C;\n    text-align: center;\n    margin: 0%;\n    padding: 4% 0;\n  }\n\n  .reset-header h2 {\n    color: #fff;\n    margin: 0%;\n  }\n  \n  .reset-form {\n    margin: 5%;\n    align-items: center;\n  }\n\n  .reset-group {\n    align-items: center;\n    padding: 5%;\n  }\n\n  .reset-group input {\n    width: 92%;\n    padding: 4%;\n    font-size: large;\n  }\n  \n  .reset-group label {\n    display: block;\n    font-weight: bold;\n  }\n\n  .reset-button {\n    align-items: center;\n    padding: 5%;\n  }\n  \n  .submit-reset {\n    width: 100%;\n    padding: 4%;\n    background-color: #4CAF50;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n  \n  .submit-reset:hover {\n    background-color: #45a049;\n  }\n  \n  .error-message {\n    color: red;\n    text-align: center;\n  }\n  \n  .success-message {\n    color: green;\n    text-align: center;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
